// © 2026 KaraokeClubs. All rights reserved.

"use client";

import { useRouter } from "next/navigation";
import { LOCALES } from "@/lib/i18n";
import type { Locale } from "@/lib/types";

interface LanguageToggleProps {
  currentLocale: Locale;
}

const FLAGS: Record<Locale, string> = {
  en: "EN",
  pl: "PL",
  uk: "UA",
};

export default function LanguageToggle({ currentLocale }: LanguageToggleProps) {
  const router = useRouter();

  function setLocale(locale: Locale) {
    document.cookie = `locale=${locale};path=/;max-age=${365 * 24 * 60 * 60}`;
    router.refresh();
  }

  return (
    <div className="flex items-center rounded-xl bg-white/[0.04] border border-white/[0.06] p-0.5">
      {LOCALES.map((locale) => (
        <button
          key={locale}
          onClick={() => setLocale(locale)}
          data-umami-event="language-switch"
          data-umami-event-locale={locale}
          className={`px-2.5 py-1.5 rounded-lg text-xs font-bold transition-all touch-manipulation ${
            currentLocale === locale
              ? "bg-violet-500/15 text-violet-300 shadow-sm shadow-violet-900/20"
              : "text-zinc-500 hover:text-zinc-300 active:scale-95"
          }`}
        >
          {FLAGS[locale]}
        </button>
      ))}
    </div>
  );
}
